module.exports = "https://img.xiyuyouxi.com/saas/img/sales_amount.5371b876.png";